/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./monetization-view.vue?vue&type=template&id=4d27414d&scoped=true"
import script from "./monetization-view.vue?vue&type=script&lang=js"
export * from "./monetization-view.vue?vue&type=script&lang=js"
import style0 from "./monetization-view.vue?vue&type=style&index=0&id=4d27414d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d27414d",
  null
  
)

export default component.exports